import './van.css';

export default function Van({activeIcon}){
    return (
        <div>
            <svg className={activeIcon} id="Group_477" data-name="Group 477" width="139.127" height="62.023" viewBox="0 0 139.127 62.023">
            <defs>
                <clipPath id="clip-path">
                <rect id="Rectangle_893" data-name="Rectangle 893" width="139.127" height="62.023" fill="#88cdf6"/>
                </clipPath>
            </defs>
            <g id="Group_476" data-name="Group 476" clip-path="">
                <path id="Path_353" data-name="Path 353" d="M135.465,34.423A18.463,18.463,0,0,0,123.544,28.1c-2.525-5.393-8.661-16.407-21.268-23.442A47.679,47.679,0,0,0,91.107.172L13.257,0A29.374,29.374,0,0,0,6.394,6.512C-2.431,18.2-1.81,36.343,6.345,48.166a32.6,32.6,0,0,0,6.626,7.059q7.513.086,15.026.163a9.519,9.519,0,0,0,18.171-.327q33.348.061,66.689.106a10.082,10.082,0,0,0,19.291-.621c.613-.36,6.5-3.914,6.953-10.475.327-4.8-2.459-8.211-3.636-9.65M37.213,59.3a6.892,6.892,0,1,1,6.888-6.9,6.9,6.9,0,0,1-6.888,6.9m57.75-32q-1.36-7.795-2.713-15.59c2.655-.033,5.311-.057,7.966-.09,11.079,7.721,17.918,15.05,16.447,17.885-1.422,2.729-10.614,1.479-21.7-2.206m27.87,32.062a6.9,6.9,0,1,1,6.9-6.9,6.9,6.9,0,0,1-6.9,6.9M135.31,42.316c-.964.915-4.093-.335-5.85-2.378-1.838-2.141-2.533-5.556-1.438-6.357,1.038-.76,3.628.9,5.082,2.459,1.879,2.01,3.211,5.319,2.206,6.275" transform="translate(0)" fill="#88cdf6"/>
            </g>
            </svg>
        </div>
    )
};